/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Missing_Items_Not_OpenInputs */

const en_error_missing_items_not_open = /** @type {(inputs: Error_Missing_Items_Not_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There is nothing to choose for the missing units of this inbound: Tomorrow has not confirmed them yet, or the choice was already made. Reload the page to see where it is.`)
};

/**
* | output |
* | --- |
* | "There is nothing to choose for the missing units of this inbound: Tomorrow has not confirmed them yet, or the choice was already made. Reload the page to see..." |
*
* @param {Error_Missing_Items_Not_OpenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_missing_items_not_open = /** @type {((inputs?: Error_Missing_Items_Not_OpenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Missing_Items_Not_OpenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_missing_items_not_open(inputs)
});